<template>
  <div>
    <b-card>
      <div class="b-skeleton-wrapper">
        <span class="skeleton-box w-100 mt-1"></span>
        <span class="skeleton-box w-100 mt-1"></span>
        <span class="skeleton-box w-100 mt-1"></span>
        <span class="skeleton-box w-100 mt-1"></span>
        <span class="skeleton-box w-100 mt-1"></span>
      </div>
    </b-card>
  </div>
</template>
